import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { PATH } from "../constant/path";

const columns: ColumnsType<any> = [
  {
    title: "Mã yêu cầu",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDateTime",
    key: "createdDateTime",
    render(value, record, index) {
      return getDDMMYYYFormat(record?.createdDateTime);
    },
  },
  {
    title: "Người tạo",
    dataIndex: "createdBy",
    key: "createdBy",
    render(value, record, index) {
      return record?.createdBy?.user?.displayName;
    },
  },
  {
    title: "Yêu cầu",
    dataIndex: "type",
    key: "type",
    render(value, record, index) {
      return <span className="flag warning">Yêu cầu</span>;
    },
  },
  {
    title: "Cơ quan/đơn vị",
    dataIndex: "eDepartment",
    key: "eDepartment",
    render(value, record, index) {
      return record?.fields?.eDepartment;
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "eRequestStatus",
    key: "eRequestStatus",
    render(value, record, index) {
      return <ApprovalStatus status={record?.fields?.eRequestStatus} />;
    },
  },
  {
    title: "Xuất tài liệu",
    dataIndex: "Download",
    key: "Download",
    render(value, record, index) {
      return (
        <Button>
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      );
    },
  },
];

export const MyApprovals: React.FC = () => {
  const history = useHistory();

  const data = [
    {
      id: "1",
      createdBy: "test",
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              history.push(PATH.CREATE);
            },
          };
        }}
        rowClassName="cursor-pointer"
      />
    </>
  );
};
